<template>
  <div id="change" >
    <div class="title" >密码找回</div>
    <p style="color: #185494;" >温馨提示: 邮箱找回密码仅适用于账号ID不是手机号的情况,若账号ID是手机号请使用验证码登录。</p>
    <div class="from" >
      <van-field
        :error-message="validator.ErrMsg.email"
        v-model="formData.email"
        placeholder="请输入账号关联邮箱">
      </van-field>
      <van-field
        :error-message="validator.ErrMsg.code"
        v-model="formData.code"
        center
        clearable
        placeholder="请输入邮件中的验证码">
        <van-button
          @click="getSmsCode()"
          slot="button"
          size="small"
          type="primary">
          {{ time ? time + 's后重新获取' : '获取邮箱验证码' }}
        </van-button>
      </van-field>
      <van-field
        :error-message="validator.ErrMsg.tel"
        v-model="formData.tel"
        placeholder="请输入邮件中的ID">
      </van-field>
      <van-field
        :error-message="validator.ErrMsg.password"
        v-model="formData.password"
        type="password"
        placeholder="请设置新密码">
      </van-field>
      <van-button class="btn" @click="setPassword()" size="large">确认</van-button>
    </div>
  </div>
</template>

<script>
import { sendSmsCode, smsLogin, forgotPassword, resetPassword } from '@/api/user'
import ValidatorUtils from '@/libs/validator'
import Vue from 'vue'
import { Field, Toast } from 'vant'
Vue.use(Field).use(Toast)
export default {
  name: 'ChangePassword',
  data() {
    return {
      time: null,
      formData: {
        email: null,
        password: null,
        code: null
      },
      rules: {
        email: [{ required: true, message: '必填信息' }],
        tel: [{ required: true, message: '必填信息' }],
        code: [{ required: true, message: '必填信息' }],
        password: [
          { required: true, message: '请输入6位到16位之间的密码' },
          {
            validator: (rule, value, callBack) => {
              /^[\w_-]{6,16}$/.test(value) ? callBack() : callBack('请输入6位到16位之间的密码')
            }
          }
        ]
      }
    }
  },
  created() {
    this.validator = new ValidatorUtils({
      rules: this.rules,
      data: this.formData })
    this.formData = this.validator.Data
  },
  methods: {
    getSmsCode() {
      if (this.time) {
        return
      }
      let field = ['email']
      this.validator.validate(field).then(
        (res) => {
          let params = {
            loginType: 'email',
            loginName: this.formData.email
          }
          forgotPassword(params).then(
            (resolve) => {
              let sms = resolve.data && resolve.data.send
              if (sms) {
                Toast('请登录邮箱查看')
                this.countDown()
              }
            },
            (reject) => { }
          )
        },
        (rej) => {
          rej.forEach((obj) => {
            this.$set(this.formData, obj.field)
          })
        }
      )
    },
    setPassword() {
      let field = ['code', 'tel', 'password']
      this.validator.validate(field).then(
        (res) => {
          let params = {
            loginName: this.formData.tel,
            resetToken: this.formData.code,
            password: this.formData.password
          }
          resetPassword(params).then((resolve) => {
            if (resolve) {
              Toast('设置成功')
            }
          }, (reject) => { })
        },
        (rej) => {
          rej.forEach((obj) => {
            this.$set(this.formData, obj.field)
          })
        }
      )
    },
    countDown() {
      this.time = 60
      let date = setInterval(() => {
        if (this.time <= 1) {
          this.time = null
          clearInterval(date)
          return
        }
        this.time -= 1
      }, 1000)
    }
  }
}
</script>

<style>
  #change {
    margin: 0 0.3rem;
  }

  #change .from .van-cell .van-cell__value .van-field__body {
    height: 50px;
    line-height: 50px;
    background:rgba(248,248,248,1);
  }

  #change .from .van-field__body .van-field__control {
    text-indent: 15px;
    font-size: 16px;
  }

  #change .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #change .van-cell {
    padding: 8px 0;
  }

  #change .van-field__body .van-field__button:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 30px;
    background-color: #CFCFCF;
    top: 10px;
  }

  #change .title {
    font-size: 36px;
    color: #185494;
    font-weight:500;
    text-align: center;
    padding: 15px;
  }

  #change .van-field__body .van-field__button .van-button {
    background-color: transparent;
    border: none;
    color: #185494;
    padding: 0 15px;
  }

  #change .van-field__error-message {
    text-indent: 15px;
  }

  #change .btn {
    height:60px;
    background:rgba(245,245,245,1);
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color:rgba(129,129,129,1);
    font-size:20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/forget-password.vue